import { useReveal } from '@ccg/core';
import React$1 from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Icon$1 from '../../basics/Icon/Icon.js';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import StyledCategoryTeaser from './CategoryTeaser.style.js';

const CategoryTeaser = ({
  headline,
  subline,
  link
}) => {
  const [ref, isVisible] = useReveal();
  return /*#__PURE__*/React$1.createElement(StyledCategoryTeaser, {
    ref: ref,
    isVisible: isVisible
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    className: "categoryTeaser__link",
    noHover: true
  }, link), /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "categoryTeaser__headline"
  }, /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "h2",
    variant: "inherit",
    text: headline
  }), /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: "rightArrow",
    alignment: "right",
    className: "categoryTeaser__icon"
  })), subline && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "categoryTeaser__subline",
    variant: "subline"
  }, subline))));
};

CategoryTeaser.propTypes = {
  headline: PropTypes$1.string.isRequired,
  subline: PropTypes$1.string,
  link: PropTypes$1.shape().isRequired
};
CategoryTeaser.defaultProps = {
  subline: null
};

export default CategoryTeaser;
